import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="top-right"
        richColors
        toastOptions={{
          classNames: {
            toast: "bg-[#0a0a0a] border border-white/10 text-white",
            title: "text-white font-body",
            description: "text-neutral-400 font-body",
          },
        }}
      />
    </div>
  );
}

export default App;
